import { render, staticRenderFns } from "./MyViolation.vue?vue&type=template&id=63f7e91e&scoped=true"
import script from "./MyViolation.vue?vue&type=script&lang=js"
export * from "./MyViolation.vue?vue&type=script&lang=js"
import style0 from "./MyViolation.vue?vue&type=style&index=0&id=63f7e91e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7e91e",
  null
  
)

export default component.exports